import React from 'react';
import { useParams } from 'react-router-dom';
import { LoadingSpinner } from '../../../Common/LoadingUI';
import EventsDetails from '../EventsDetail';
import EventImageVideoGallery from '../EventImageVideoGallery';
import useDataEventDetails from '../EventsDetail/data';
import { jsx as _jsx } from "react/jsx-runtime";
var EventsDetailsRoute = function EventsDetailsRoute(_ref) {
  var config = _ref.config,
    winnreNoAuth = _ref.winnreNoAuth,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient,
    isAuthenticated = _ref.isAuthenticated,
    theme = _ref.theme,
    ThemeProvider = _ref.ThemeProvider,
    ComponentsRenderer = _ref.ComponentsRenderer,
    FilterOptions = _ref.FilterOptions,
    Banner = _ref.Banner,
    Modal = _ref.Modal,
    authActions = _ref.authActions;
  var _useParams = useParams(),
    eventId = _useParams.eventId;
  var _useDataEventDetails = useDataEventDetails(eventId, {
      winnreAuth: winnreAuth,
      cmsClient: cmsClient,
      isAuthenticated: isAuthenticated
    }),
    event = _useDataEventDetails.event,
    isLoading = _useDataEventDetails.isLoading;
  var endDate = new Date(event === null || event === void 0 ? void 0 : event.endDate);
  var currentDate = new Date();
  if (currentDate <= endDate) {
    return /*#__PURE__*/_jsx(EventsDetails, {
      event: event,
      isLoading: isLoading,
      config: config,
      winnreNoAuth: winnreNoAuth,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient,
      isAuthenticated: isAuthenticated,
      Modal: Modal,
      authActions: authActions
    });
  } else {
    return /*#__PURE__*/_jsx(EventImageVideoGallery, {
      event: event,
      isLoading: isLoading,
      config: config,
      winnreNoAuth: winnreNoAuth,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient,
      isAuthenticated: isAuthenticated
    });
  }
};
export default EventsDetailsRoute;